import { TermCourseQuery } from '../../../term_courses/queries/term_courses_query';
import * as _4 from 'lodash4';
import { ToggleQuickScheduleErrorCommand } from '../commands/toggle_quick_schedule_error_command';

export class QuickScheduleFacade {
  constructor(
    private $state: ng.ui.IStateService,
    private ngTermCourseQuery: TermCourseQuery,
    private toggleQuickScheduleErrorCommand: ToggleQuickScheduleErrorCommand
  ) {}

  closeQuickScheduleError() {
    this.toggleQuickScheduleErrorCommand(false);
  }

  quickScheduleAction() {
    const isPlannedCoursesEmpty = _4.isEmpty(this.ngTermCourseQuery.result.unscheduled);
    if (isPlannedCoursesEmpty) {
      const showQuickScheduleError = true;
      return this.toggleQuickScheduleErrorCommand(showQuickScheduleError);
    }
    return this.$state.go('my.schedule.quickscheduler');
  }
}

angular.module('capability-ng-scheduler').service('ngQuickScheduleFacade', QuickScheduleFacade);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/aside/scheduler_navigation/facades/quick_schedule_facade.ts